import React, { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";

import { Col, Row, InputGroup, FormControl, ListGroup } from "react-bootstrap";

import {
  createUserRole,
  updateUserRole,
  fetchUserRole,
  fetchUserRoles,
  deleteUserRole,
} from "actions/userRoles";

import cx from "classnames";
import _ from "lodash";

import styles from "./manageRoles.module.scss";

function ManageRoles() {
  const [selectedRole, setSelectedRole] = useState(0);
  const [roles, setRoles] = useState({
    creating: false,
    name: "",
    permissions: {},
  });

  const dispatch = useDispatch();

  const userRoles = useSelector((state) => _.get(state, "userRoles.items", []));

  let history = useHistory();
  let path = useRouteMatch();

  const handleCreateUserRole = () => {
    history.replace(`${path.url}/new`);
    setRoles({
      creating: true,
      name: "Untitled",
      permissions: {},
    });
  };

  const handleCancelCreate = () => {
    setRoles({
      creating: false,
      errors: {},
    });
    history.replace(`${path}/user-managemnet/manage-roles`);
  };

  const handleSaveChanges = () => {
    var request = {
      name: roles.name,
      ...roles.permissions,
    };

    if (path.params.id === "new") {
      dispatch(
        createUserRole(request, (response) => {
          history.replace(`${path.url}/${response.payload.id}`);
          setRoles({
            creating: false,
          });
        })
      );
    } else {
      dispatch(updateUserRole(path.id, request));
    }
  };

  const handleDeleteRole = () => {
    dispatch(deleteUserRole(path.id));
    if (userRoles.length > 0) {
      history.replace(`${path.url}/${userRoles[0].id}`);
    }
  };

  const handleRoleNameChange = (event) => {
    setRoles({ name: event.target.value,creating: roles.creating });
  };

  useEffect(() => {
    dispatch(fetchUserRoles());
  }, []);

  useEffect(() => {
    if (path.params.id != "new") {
      dispatch(fetchUserRole(path.id));
      setRoles({
        creating: false,
      });
    } else {
      setRoles({
        creating: true,
        name: "Untitled",
        permissions: {},
      });
    }
  }, [path]);

  return (
    <Row className={styles.manageRolesRow}>
      <div className={styles.verticalLine}></div>

      <Col className={styles.manageCol} md={4}>
        <h5
          onClick={() => history.replace(`/app/:id/user-management`)}
          className={styles.heading}
        >
          ^ Manage Role
        </h5>
        <span onClick={handleCreateUserRole} className={styles.createRoles}>
          + Create Roles
        </span>
        <div className={styles.searchRolesContent}>
          <InputGroup className={styles.searchInputGroup} size="sm">
            <InputGroup.Text className={styles.searchIcon}>
              <i className={cx("cleverstory-search")} />
            </InputGroup.Text>
            <FormControl
              className={styles.searchInput}
              placeholder="Search by user here"
            />
          </InputGroup>
          <ListGroup className={styles.userRoleList}>
            {roles.creating && (
              <ListGroup.Item
                onClick={() => setSelectedRole(0)}
                className={cx(styles.userRoleListItem, {
                  [styles.userRoleSelected]: selectedRole === 0,
                })}
              >
                Untitled
              </ListGroup.Item>
            )}

            {userRoles.map((item, index) => {
              return (
                <ListGroup.Item
                  onClick={() => setSelectedRole(index + 1)}
                  className={cx(styles.userRoleListItem, {
                    [styles.userRoleSelected]: selectedRole === index + 1,
                  })}
                >
                  {item.name}
                </ListGroup.Item>
              );
            })}
          </ListGroup>
        </div>
      </Col>
      <Col className={styles.editRolesCol} md={8}>
        <div className={styles.headerContent}>
          <h5 className={styles.heading}>Edit Role</h5>
          <div onClick={handleDeleteRole} className={styles.deleteUserRole}>
            <i className={cx("cleverstory-plus")} />
            <span className={styles.deleteRole}>Delete</span>
          </div>
        </div>

        <div className={styles.roleName}>
          <label className={styles.roleNameLabel}>Role Name:</label>
          <input
            className={styles.roleNameInput}
            type="text"
            onChange={handleRoleNameChange}
            value={roles.name}
          />
        </div>

        <div className={styles.permissionHeader}>
          <h6 className={styles.permissions}>Permissions</h6>
          <p className={styles.summary}>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod
          </p>
        </div>

        <InputGroup className={styles.permissionInputGroup}>
          <div className={styles.permissionRadioGroup}>
            <input className={styles.permissionRadio} type="radio" />
            <div className={styles.permissionInputHeader}>
              <span className={styles.header}>Admin (Owner)</span>
              <p className={styles.subheader}>
                Has full access to manage, edit & publish site, including
                billing, domains and inviting people, but cannot delete or
                transfer site.
              </p>
            </div>
          </div>
          <div className={styles.permissionRadioGroup}>
            <input className={styles.permissionRadio} type="radio" />
            <div className={styles.permissionInputHeader}>
              <span className={styles.header}>View Access</span>
              <p className={styles.subheader}>
                Has full access to manage, edit & publish site, including
                billing, domains and inviting people, but cannot delete or
                transfer site.
              </p>
            </div>
          </div>
          <div className={styles.permissionRadioGroup}>
            <input className={styles.permissionRadio} type="radio" />
            <div className={styles.permissionInputHeader}>
              <span className={styles.header}>Create Storyboard</span>
              <p className={styles.subheader}>
                Has full access to manage, edit & publish site, including
                billing, domains and inviting people, but cannot delete or
                transfer site.
              </p>
            </div>
          </div>
        </InputGroup>
      </Col>

      <div className={styles.buttonGroup}>
        <button className={styles.cancel}>Cancel</button>
        <button onClick={handleSaveChanges} className={styles.save}>
          Save Changes  
        </button>
      </div>
    </Row>
  );
}

export default ManageRoles;
